// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZKcoP","content":"styles_content__1XVar","tableWrap":"styles_tableWrap__68TB4"};